// extracted by mini-css-extract-plugin
export default {"ldsRing":"Loading_ldsRing__E4n4j"};